import { render, staticRenderFns } from "./RSRecordList.vue?vue&type=template&id=0f9383a7&scoped=true"
import script from "./RSRecordList.vue?vue&type=script&lang=js"
export * from "./RSRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9383a7",
  null
  
)

export default component.exports